import React from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import AdminAccessOrganizationSearchContent from "./AdminAccessOrganizationSearchContent"
import AdminAccessUserConfigContent from "./AdminAccessUserConfigContent"
import { applicationsMainteiner } from "../../../utils/UserTools"

export const AdminAccessUserApp = () => {

  return (
    <Routes>
      {applicationsMainteiner.map((appCode) => (
        <>
          <Route
            path={`application${appCode}`}
            element={
              <AdminAccessOrganizationSearchContent applicationCode={appCode} />
            }
          />
          <Route
            path={`application${appCode}/user/:userId`}
            element={<AdminAccessUserConfigContent />}
          />
        </>
      ))}
      <Route
        path="*"
        element={<Navigate replace to="/" />}
      />
    </Routes>
  )
}

export default AdminAccessUserApp
